import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../shared/utility";


const initialState = {
    /*vin: null,
    mileage: null,
    condition: null,
    performancePackage: null,
    premiumWheels: null,
    premiumSoundSystem:  null,
    uncontrolled: null,
    leatherSeats: null*/
}


const setData = (state, action) => {
    return updateObject(state, {...action.data})
}

const resetData = (state, action) => {
    return {}
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_NEW_VEHICLE:
            return setData(state, action);
        case actionTypes.SAVE_NEW_VEHICLE:
            return setData(state, action);
        case actionTypes.RESET_NEW_VEHICLE:
            return resetData();
        default:
            return state;
    }
};

export default reducer;